import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isTekikakuInvoiceNo', (values, value) => {
  if (!value || value === '') return true
  // return value.replace(/-|T/g, '').match(/^[0-9]{13}$/)
  return value.match(/^T{1}[0-9]{1}-[0-9]{4}-[0-9]{4}-[0-9]{4}$/)
})
